module.exports = __webpack_public_path__ + "img/main-video-cover.ca2d1b0.jpg";